import {BaseComponentWithContext} from '@mintdata/mint-kit/api/components/BaseComponentWithContext';
import {IPopup, IPopupProps, PopupKind} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';

export abstract class Popup extends BaseComponentWithContext<IPopupProps> implements IPopup
{
    public static defaultProps:Partial<IPopupProps> = {
        disablePointerEvents: false,
    };

    public abstract getKind():PopupKind;

    public constructor(props:any)
    {
        super(props);
    }

    public componentWillMount():void
    {
        const {popupManager} = this.context;

        if( popupManager )
            popupManager.registerPopup(this, this.props);
    }

    public componentWillReceiveProps(nextProps:Readonly<IPopupProps>, nextContext:any):void
    {
        const {popupManager} = this.context;

        if( popupManager )
            popupManager.updatePopup(this, nextProps);
    }

    public componentWillUnmount():void
    {
        const {popupManager} = this.context;

        if( popupManager )
            popupManager.unregisterPopup(this);
    }

    public render():JSX.Element
    {
        // Portals are not needed; see registerPopup() method above.
        // When combined with the reactiveness of mobx, we get the same effect.
        return null;
    }
}
